var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H60C62.2091 0 64 1.79086 64 4V60C64 62.2091 62.2091 64 60 64H4C1.79086 64 0 62.2091 0 60V4Z",
    fill: "#D6D6E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9101 26.953L32.7001 21.672C32.256 21.4427 31.7282 21.4427 31.2841 21.672L21.0761 26.953C20.8711 27.0584 20.7422 27.2695 20.7422 27.5C20.7422 27.7305 20.8711 27.9417 21.0761 28.047L31.2851 33.328C31.7292 33.5574 32.257 33.5574 32.7011 33.328L42.9101 28.047C43.1145 27.9412 43.2428 27.7302 43.2428 27.5C43.2428 27.2698 43.1145 27.0589 42.9101 26.953Z",
    stroke: "#26253E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7578 32.75L31.2848 37.828C31.7289 38.0574 32.2567 38.0574 32.7008 37.828L43.2578 32.75",
    stroke: "#26253E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7578 37.25L31.2848 42.328C31.7289 42.5574 32.2567 42.5574 32.7008 42.328L43.2578 37.25",
    stroke: "#26253E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultLogo);
export default __webpack_public_path__ + "static/media/DefaultLogo.336e542975d538c8f36e267e0b2aa374.svg";
export { ForwardRef as ReactComponent };